// Vendor functions needed within this file
//import Player from '@vimeo/player';

// Do not scroll directly to the hash, animate the scroll
/*var hash = window.location.hash, $w = $(window),
    windowWidth = $w.width(), windowHeight = $w.height(),
    blocksOnPage = $('.block'),
    $doc = $(document), docHeight = $doc.height();
if ( ! $('body').hasClass('blog') ) {
  if (hash.length) {
    window.location.hash = "";
  }
}*/

var hash = window.location.hash, 
    $w = $(window),
    windowWidth = $w.width(), 
    windowHeight = $w.height(),
    blocksOnPage = $('.block'),
    $doc = $(document), 
    docHeight = $doc.height();

if (!$('body').hasClass('blog')) {
  if (hash.length) {
    // Remove the hash without reloading the page
    history.replaceState(null, null, window.location.pathname + window.location.search);
  }
}


// Animate the scroll to an anchor: the further away, the longer it takes
function scrollToID(id) {
  if ($('#'+id).length) {
    var offset = $('#'+id).offset().top - $('.menu-sticky.main-menu-container').outerHeight() - 10;
    var time = 400 + Math.round(Math.abs($w.scrollTop() - offset)/2);
    $('html,body').animate({scrollTop: offset+'px'}, time);
  }
}

// Remove the trailing slash if one exists, to check for URL matches
var stripTrailingSlash = function(str) {
  if (str.substr(-1)==='/') {
    return str.substr(0, str.length - 1);
  }
  return str;
};

function sizeFormLabels() {
  if ($('.form').length) {
    if (windowWidth >= 768) {
      if ($('html').hasClass('wf-poppins-n7-active') || $('html').hasClass('wf-poppins-n7-inactive')) {
        $('.form').each(function() {
          var $form = $(this);
          if ($form.find('.ginput_text .gfield_label').length) {
            $form.find('.ginput_text .gfield_label').css({'width':'auto', 'min-width':'0px'})
                 .siblings('.gfield_description.validation_message').css('left', 'auto');
            var longest = 0;
            $(this).find('.ginput_text .gfield_label').each(function() {
              var thisWidth = $(this).outerWidth();
              if (thisWidth > longest) {
                longest = Math.ceil(thisWidth);
              }
            });
            if (longest < windowWidth / 2) {
              $form.find('.ginput_text .gfield_label').css('min-width', longest+'px')
                   .siblings('.gfield_description.validation_message').css('left', longest+'px');
            }
          }
        });
      } else {
        setTimeout(sizeFormLabels, 200);
      }
    }
  }
}

function revealBlocks() {
  var screenTop = $w.scrollTop(),
      screenBottom = screenTop + windowHeight;
  blocksOnPage.each(function(i) {
    var id = $($(this)[0]).prop('id');
    if (id) {
      var $block = $('#'+id),
          sectionTop = Math.round($block.offset().top),
          sectionBottom = sectionTop + Math.round($block.outerHeight());
      if (sectionTop < screenBottom && screenTop < sectionBottom) {
        if (!$block.hasClass('active')) {
          $block.addClass('active');
          blocksOnPage.splice(i, 1);
          if (blocksOnPage.length===0) {
            $w.off('scroll.block');
          }
        }
      }
    }
  });
  if (screenBottom >= docHeight) {
    var $block = $('#footer');
    if (!$block.hasClass('active')) {
      $block.addClass('active');
      $.each(blocksOnPage, function(i){
        if ($(blocksOnPage[i]).prop('id')==='footer') {
          blocksOnPage.splice(i,1);
          if (blocksOnPage.length===0) {
            $w.off('scroll.block');
          }
          return false;
        }
      });
    }
  }
}

function overlapMinHeight() {
  $('.overlap').each(function() {
    var $block = $(this).parents('.block'),
        $below = $(this).siblings('.v-below');
    if ($block.hasClass('text-with-widening-image') || $block.hasClass('thought-header')) {
      $below = $block.find('.text-wrap');
    } else if ($block.hasClass('grid-links')) {
      $block = $(this).parents('.post-wrap');
      $below = $block.find('.text-wrap');
    }
    $block.css('minHeight', 'none');
    var height = Math.round($(this).outerHeight());
    $block.css('minHeight', height+'px');
    $below.css('paddingTop', height+'px');
  });
}

function checkForFormElements() {
  if ($('select').length) {
    const select2 = require('select2');
    const niceScroll = require('nicescroll');
    $('select').each(function() {
      var scrollable = false;
      $(this).select2({
        minimumResultsForSearch: 100,
        placeholder: {
          id: '-', // the select must include an option with a hyphen value to remove the placeholder option
          text: 'Select an option'
        }
      })
      .on('select2:open', function () {
        $('.select2-dropdown').hide();
        setTimeout(function(){
          $('.select2-dropdown').slideDown(200, function() {
            if (scrollable) {
              $('.select2-results__options').getNiceScroll().resize();
            } else {
              $('.select2-results__options').niceScroll({
                cursoropacitymin: 1, // hidden state (always visible)
                cursorwidth: "24px",
                cursorborder: "none",
                cursorborderradius: "0",
              });
              scrollable = true;
            }
          });
        }, 100);
      })
      $doc.on('focus', 'select', function(e) {
        if (e.originalEvent) {
          $(this).select2('open');
        }
      });
    });
  }
  if ($('textarea').length) {
    const autosize = require('autosize');
    autosize($('textarea'));
  }
}

function extendRules() {
  if ($('.grid-links').length || $('.single-header').length) {
    if (windowWidth >= 768) {
      $('.grid-links, .single-header').each(function() {
        var $block = $(this), $hr = $block.find('hr'), $posts = $block.find('.posts-wrap'),
            marginFromEdge = 46, oriented = 'left', opposite = 'right', evenOdd = 'odd';
        if ($posts.length && $posts.hasClass('h-right')) {
          oriented = 'right';
          opposite = 'left';
          evenOdd = 'even';
        }

        // recontextualize for 2 per line
        if ($block.hasClass('grid-links')) {
          var $single = $block.find('.post-wrap:nth-child('+evenOdd+')');
          $hr = $single.find('hr');
          marginFromEdge -= Math.round(parseInt($single.first().css('padding-left')));
          if (oriented==='right') {
            marginFromEdge -= Math.round($single.first().outerWidth());
          } else {
            marginFromEdge -= Math.round($block.width());
            marginFromEdge += Math.round($single.first().find('.text-wrap').width());
          }
          $block = $posts;
          
          var pinnedEdge = Math.round($block.offset().left - marginFromEdge)*-1;
          $hr.css('margin-'+opposite, pinnedEdge+'px');

          var $last = $block.find('.post-wrap:last-child'), lastIndex = $last.index(), marginFromEdge = 46;
          if (lastIndex%2===0 && oriented==='right') {
            $hr = $last.find('hr');
            marginFromEdge -= Math.round(parseInt($last.css('padding-left')));
            var pinnedEdge = Math.round($last.offset().left - marginFromEdge)*-1;
            $hr.css('margin-'+opposite, pinnedEdge+'px');
          }
        }
      });
    }
  }
}

jQuery(document).ready(function($) {
  var $body = $('body'),
      throttle, docHeight = $doc.height(),
      loaded = [], totalSizes = sizes.length;

  if (sizes && stylesheets) {
    for (var i=0; i<totalSizes; i++) {
      loaded[sizes[i]] = (windowWidth > sizes[i]) ? true : false;
    }

    var loadStylesLater = function() {
      for (i=0; i<totalSizes; i++) {
        var size = sizes[i];
        if (loaded[size]===false && windowWidth >= size) {
          var importer = '';
          for (var j=0, totalSheets = stylesheets[size].length; j<totalSheets; j++) {
            importer += '@import url("'+theme_url+'/public/css/blocks/'+stylesheets[size][j]+'-'+size+'.css");';
          }
          $('<style type="text/css"></style>').html(importer).appendTo('body');
          loaded[size] = true;
        }
      }
    };
  }


  // a quick plugin to use passive event listeners
  jQuery.event.special.scroll = {
    setup: function( _, ns, handle ){
      this.addEventListener("scroll", handle, { passive: true });
    }
  };
  jQuery.event.special.resize = {
    setup: function( _, ns, handle ){
      this.addEventListener("resize", handle, { passive: true });
    }
  };


  // Make any anchor links scroll as well
  $doc.on('click', 'a', function(e) {
    if (typeof($(this).attr('href'))!=='undefined' && $(this).attr('href').length) {
      var linkParts = $(this).attr('href').split('#'), locationParts = window.location.href.split('#');
      if (linkParts.length===2 && stripTrailingSlash(linkParts[0])===stripTrailingSlash(locationParts[0]) || stripTrailingSlash(linkParts[0])==='') {
        e.preventDefault();
        scrollToID(linkParts[1]);
      }
    }
  });


  // Lazy load images
  $('img.lazy:not(.loaded)').each(function() {
    var $this = $(this);

    $this.on('load', function() {
      // mark image as loaded
      $(this).addClass('loaded');
      overlapMinHeight();
    });

    // actually switch the image source
    $this.prop('src', $(this).data('src'));
    if ($(this).data('srcset')) {
      // and possibly srcset
      $(this).prop('srcset', $(this).data('srcset'));
      $(this).removeAttr('data-srcset')
    }
    $(this).removeAttr('data-src');
  });

  $('.lazyBG:not(.loaded)').each(function() {
    $(this).css('backgroundImage', 'url('+$(this).data('bg')+')');
    $(this).removeAttr('data-bg');
  });


  // Change the background based on scroll percentage
  var $background = $('.background'),
      percent = 0,
      cStart = [28, 33, 45], // rgb values of $bg-blue
      cEnd = [52, 119, 131], // rgb values of $bg-pink
      cDiff = [cEnd[0] - cStart[0], cEnd[1] - cStart[1], cEnd[2] - cStart[2]];
  $w.on('scroll.background', function() {
    if (docHeight > windowHeight*1.3) { // document must be higher than the window + 30% more
      $background.removeClass('gradient');
      percent = $w.scrollTop() / (docHeight - windowHeight);
      percent = Math.min(1, Math.max(0, percent)); // must be 0-1
      var cBg = [
        Math.round(cStart[0] + cDiff[0] * percent), // r
        Math.round(cStart[1] + cDiff[1] * percent), // g
        Math.round(cStart[2] + cDiff[2] * percent)  // b
      ];
      $background.css('background-color', 'rgb(' + cBg.join(',') +')');
      if (percent > 0.5) {
        $body.addClass('invert');
      } else {
        $body.removeClass('invert');
      }
    } else {
      $background.addClass('gradient');
    }
  });


  // Setup Videos
  if ($('.video-wrap.vimeo').length) {
    const VimeoPlayer = require('@vimeo/player/dist/player.min');
    $('.video-wrap.vimeo').each(function() {
      var $this = $(this), id = $this.find('.player').prop('id');
      var color = '#ff6d6a';
      var player = new VimeoPlayer(id);
      $this.find('.overlay').on('click', function() {
        if ($body.hasClass('invert')) {
          color = '#6b6bff';
        }
        player.setColor(color);
        player.play().then(function() {
          $this.addClass('playing');
        }).catch(function(error) {
          console.log(error);
        });
      });
    });
  }
  if ($('.video-wrap.youtube').length) {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Continued in footer.php, as YouTube script needs to be at root level
  }


  // Setup sliders
  if ($('.slideshow').length) {
    const slick = require('slick-carousel');
    $('.slideshow').each(function() {
      var options = {
        'autoplay': false,
        'prevArrow': '.prev.arrow',
        'nextArrow': '.next.arrow',
        'adaptiveHeight': true,
        'mobileFirst': true
      };
      var autoplaySpeed = parseInt($(this).parents('.image-wrap').data('autoplay'));
      if (autoplaySpeed > 0) {
        options.autoplay = true;
        options.autoplaySpeed = autoplaySpeed;
      }
      $(this).slick(options);
    });
  }


  // Forms
/*   if ($('.gform_wrapper').length) {
    $doc.bind('gform_post_render', function(){
      checkForFormElements();
      sizeFormLabels();
      if (windowWidth >= 768) {
        $('.form').find('input, textarea, select').on('focus', function() {
          $(this).parents('.gfield').find('.gfield_description.validation_message').remove();
        });
      }
    });
  } else {
    checkForFormElements();
  } */

  $w.on('resize', function() {
    clearTimeout(throttle);
    throttle = setTimeout(function() {
      windowWidth = $w.width();
      windowHeight = $w.height();
      docHeight = $doc.height();
      //sizeFormLabels();
      overlapMinHeight();
      extendRules();
      $w.trigger('scroll');
      if (sizes && stylesheets) {
        loadStylesLater();
      }
    }, 100);
  });
});


// Everything's completely loaded, call some functions
$w.on('load', function() {
  $('html').removeClass('no-js').addClass('loaded');
  docHeight = $doc.height();
  overlapMinHeight();
  //sizeFormLabels();
  extendRules();

  if (blocksOnPage) {
    var blockThrottle;
    $w.on('scroll.block', function() {
      clearTimeout(blockThrottle);
      blockThrottle = setTimeout(revealBlocks, 10);
    });
  }

  if (hash.length) {
    setTimeout(function() {
      // Then scroll to hash with a transition
      scrollToID(hash.substr(1));
    }, 20);
  } else {
    revealBlocks();
  }

});

document.addEventListener("DOMContentLoaded", function() {
  function addClassToLastRow() {
      // Get all .icons-inner-wrap containers
      const iconContainers = document.querySelectorAll('.icons-inner-wrap');

      // Loop through each container
      iconContainers.forEach(container => {
          const iconWraps = container.querySelectorAll('.icon-wrap');
          const itemsPerRow = window.innerWidth >= 768 ? 4 : 2; // 4 for desktop, 2 for mobile
          const totalItems = iconWraps.length;
          const lastRowItems = totalItems % itemsPerRow || itemsPerRow;

          // Remove any existing last-row classes
          iconWraps.forEach(icon => icon.classList.remove('last-row'));

          // Add the last-row class to the items in the last row
          for (let i = totalItems - lastRowItems; i < totalItems; i++) {
              iconWraps[i].classList.add('icon-wrap-last');
          }
      });
  }

  // Run the function on load and on window resize
  addClassToLastRow();
  window.addEventListener('resize', addClassToLastRow);
  
});



